import { tournamentsAdapter } from "@/lib/adapters/firestore";
import { Tournament } from "@/types";
import { useQuery } from "@tanstack/react-query";

export const useTournament = (tournamentId: Tournament["id"]) => {
  return useQuery({
    queryKey: ["tournament", tournamentId],
    queryFn: () => tournamentsAdapter.getById(tournamentId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
